import { ref } from 'vue';

import { Language } from '@/types/mode-list-locale';

const currentLocale = ref<Language>(Language.FRENCH);
export default function useLocale() {
  function setupCurrentLocale(locale: string) {
    if (locale === 'fr' || locale === 'fr-FR') {
      currentLocale.value = Language.FRENCH;
    }
    else if (locale === 'es-ES') {
      currentLocale.value = Language.SPANISH;
    }
    else if (locale === 'de-DE') {
      currentLocale.value = Language.GERMAN;
    }
    else {
      currentLocale.value = Language.ENGLISH;
    }
  }

  return {
    currentLocale,
    setupCurrentLocale,
  };
}
